<script lang="ts">
  import { Icon, Nav, MobileNav, CtaModel, NavItem, Button } from '@centerhealth/fe/center-kit';
  import { queryParameters } from '@centerhealth/fe/stores';

  // position: sticky or absolute
  export let position: 'sticky' | 'absolute' | 'relative' = 'absolute';
  export let navItems: NavItem[] = [];
  export let cta: CtaModel | null = null;
  export let customClass = '';
  export let showStickyBanner = false;

  // Add type to query parameters
  let queryParams: string;
  $: queryParams = $queryParameters;
  let showMobileNav = false;

  // update nav items if query params are found
  $: navItemsWithQuery = navItems.map((navItem) => ({
    ...navItem,
    link: `${navItem.link}${queryParams}`,
  }));
</script>

<header class={['py-1', 'bg-transparent', `header--${position}`, 'z-20', customClass].join(' ')}>
  {#if showStickyBanner}
    <Button
      heapAttr={{
        action: 'cta',
        subAction: 'subscribe',
        sectionName: 'nav',
      }}
      block
      size="small"
      href="/subscribe"
      customClass="!py-[3px] !mb-[10px] !rounded-none !w-full"
      customAnchorClass="!mt-[-12px]"
    >
      <p class="text-sm text-center text-white">Order your meter today</p>
    </Button>
  {/if}

  <div class="px-[1rem] xs:px-[2rem] xl:container flex justify-between items-center mx-auto">
    <a href={`/${queryParams}`}>
      <img
        width="190"
        height="42"
        class={[`logo--${position}`, 'w-56', 'xs:w-60', 'lg:-ml-[8px]'].join(' ')}
        src="/assets/branding/logo.webp"
        alt="Center Health"
      />
    </a>
    <div class="hidden xl:flex">
      <Nav navItems={navItemsWithQuery} {cta} gap="medium" />
    </div>
    <div class="mobile-icon xl:hidden">
      {#if showMobileNav}
        <Icon name="close" on:click={() => (showMobileNav = false)} />
      {:else}
        <Icon name="menu" on:click={() => (showMobileNav = true)} />
      {/if}
    </div>
  </div>
  {#if showMobileNav}
    <MobileNav
      on:click-listener={() => (showMobileNav = false)}
      navItems={navItemsWithQuery}
      {cta}
    />
  {/if}
</header>

<style>
  header {
    @apply transform;
    @apply transition;
    @apply duration-200;
    @apply ease-in-out;
  }

  .logo--sticky {
    height: 42px;
    width: fit-content;
    object-fit: contain;
  }

  .header--sticky {
    position: fixed;
    top: 0;
    width: 100%;
    @apply py-2;
    @apply bg-white;
    @apply shadow-sm;
  }

  .header--absolute {
    position: absolute;
    width: 100%;
    top: 5px;
  }

  .header--relative {
    position: relative;
    width: 100%;
  }
</style>
